import React from "react";
import { ListItemText } from "@mui/material";
import { NavElement } from "type/navigation/main_navigation.type";
import LinkTo from "components/navigation/link/LinkTo";
import { useAuthCurrent } from "hooks/auth/auth_current";
import { USER_TYPE } from "constant/user/user.constant";

export type MainNavItemProps = {
  navImage?: React.ReactNode;
  navElement: NavElement;
};

/** Link component for main navigation */

export default function MainNavItem({ navElement }: MainNavItemProps) {
  const authCurrent = useAuthCurrent();

  if (!navElement) return null;

  if (navElement.adminAccess && authCurrent?.uType !== USER_TYPE.ADMIN) {
    return null;
  }

  return (
    <LinkTo to={navElement.path} key={navElement.path}>
      <ListItemText primary={navElement.title} />
    </LinkTo>
  );
}
